export const MODELS = 0
export const CATALOGS = 1
export const TECH_DOCS = 2
export const SCHEME = 3
export const DRAWING = 4
export const BIM_MODEL = 5
export const TECH_ARTICLE = 6
export const EDU_DOCUMENTATION = 7
export const LETTER = 8
export const DISTRIBUTION_KIT = 9
export const UPDATE_KIT = 10
export const FIRMWARE_KIT = 11
export const IES_LDT = 12
export const PROJECT = 13
export const GUIDE = 14
export const PASSPORT = 15
export const CONFIGURATION = 16

const titles = {
    [MODELS]: '3D модель',
    [CATALOGS]: 'Каталог',
    [TECH_DOCS]: 'Техническая документация',
    [SCHEME]: '2D схема',
    [DRAWING]: '2D чертёж',
    [BIM_MODEL]: 'BIM модель',
    [TECH_ARTICLE]: 'Техническая статья',
    [EDU_DOCUMENTATION]: 'Документ центра обучения',
    [LETTER]: 'Официальное письмо',
    [DISTRIBUTION_KIT]: 'ПО (дистрибутив)',
    [UPDATE_KIT]: 'ПО (обновления, дополнения, языковые пакеты)',
    [FIRMWARE_KIT]: 'ПО (прошивки firmware)',
    [IES_LDT]: 'IES/LDT',
    [PROJECT]: 'Типовые проекты',
    [GUIDE]: 'Руководства',
    [PASSPORT]: 'Паспорта на продукцию',
    [CONFIGURATION]: 'Опросные листы и конфигураторы',
}

export const getType = (type) => {
    return titles[type]
}